import {useState} from 'react';

import {MAX_AUTOMATION_TEMPLATE_DESCRIPTION_LENGTH} from 'analysis-tool/AnalysisToolConstants';

export interface AnalysisTemplateDescriptionState {
  description: string | null;
  normalizedDescription: string | null;
  isDescriptionTooLong: boolean;
  descriptionHelpText: string;
  descriptionError: string | null;

  setDescription: (description: string) => void;
}

export function useAnalysisTemplateDescriptionState(
  initialDescription: string | null
): AnalysisTemplateDescriptionState {
  const [description, setDescription] = useState(initialDescription);

  const normalizedDescription = description?.trim() || null;
  const descriptionLength = normalizedDescription?.length ?? 0;
  const isDescriptionTooLong = descriptionLength > MAX_AUTOMATION_TEMPLATE_DESCRIPTION_LENGTH;

  return {
    description,
    normalizedDescription,
    isDescriptionTooLong,
    descriptionHelpText: `${descriptionLength} of ${MAX_AUTOMATION_TEMPLATE_DESCRIPTION_LENGTH} allowed characters.`,
    descriptionError: isDescriptionTooLong
      ? `Description must be at most ${MAX_AUTOMATION_TEMPLATE_DESCRIPTION_LENGTH} characters.`
      : null,

    setDescription,
  };
}
